// @ts-check
/* eslint-env browser */

import { reactiveStore } from '../reactive-store.js'

/**
 * A singleton class handling the auto-saving of job metadata to the server by subscribing to reactiveStore.jobData
 */
export class JobDataAutosave {
  #jobId
  #previousData = null

  /**
   * @param {string} jobId
   */
  constructor (jobId) {
    this.#jobId = jobId
    this.#previousData = reactiveStore.jobData.get()
    reactiveStore.jobData.subscribe(this.#subscriber.bind(this))
  }

  #subscriber (currentData, message) {
    if (typeof message === 'string' && message.startsWith('no-save')) {
      this.#previousData = currentData
      return
    }

    if (!this.#jobId) {
      this.#previousData = currentData
      return
    }

    // Check if data has changed
    if (JSON.stringify(currentData) === JSON.stringify(this.#previousData)) {
      return
    }

    this.#previousData = currentData

    // Queue the save
    this.#save(currentData)
  }

  async #save (data) {
    const body = new URLSearchParams()
    for (const [key, value] of Object.entries(data)) {
      if (key === 'reviewed') continue // handled explicitly below
      body.append(key, value == null ? '' : String(value))
    }
    body.append('extraction_result_id', window['extractionResultId']) // eslint-disable-line dot-notation
    // all changes should reset the status to "For review"
    body.append('reviewed', 'false')

    try {
      const response = await fetch(`/extractions/${this.#jobId}/entity/${this.#jobId}/properties`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body
      })

      if (!response.ok) {
        throw new Error('Failed to autosave job metadata')
      }
    } catch (error) {
      console.error('job-data-autosave: Failed to save job metadata', error)
    }
  }
}
